import * as React from 'react'
import { observer } from 'mobx-react'
import { useScrollOffsetSpring } from 'hooks/spring-hooks'
import { Sandwich, SandwichBun, SandwichContent } from 'components/Sandwich'
import NavItem from '../../../components/NavItem'
import link from 'infra/link'
import { SplitViewHeader, SplitViewHeaderTitle } from 'components/SplitView'
import ProfileViewModel from '../ProfileViewModel'
import ScrollView from 'components/ScrollView'

interface ProfileNavProps {
  vm: ProfileViewModel
}

export default observer(function ProfileNav({ vm }: ProfileNavProps) {
  const scrollRef = React.useRef<HTMLDivElement | null>(null)
  const scrollOffset = useScrollOffsetSpring(scrollRef)
  return (
    <Sandwich stretch>
      <SandwichBun>
        <SplitViewHeader compact scrollOffset={scrollOffset}>
          <SplitViewHeaderTitle>
            {vm.member.workspace.name} &ndash; User Account
          </SplitViewHeaderTitle>
        </SplitViewHeader>
      </SandwichBun>
      <SandwichContent>
        <ScrollView ref={scrollRef}>
          <NavItem to={link.profileGeneral()} title="General">
            Manage your profile and visibility
          </NavItem>
          {vm.shouldShowBilling && (
            <NavItem to={link.profileBilling()} title="Billing">
              Manage payment and payout methods
            </NavItem>
          )}
          <NavItem to={link.profileNotifications()} title="Notifications">
            Manage email and push notifications
          </NavItem>
        </ScrollView>
      </SandwichContent>
    </Sandwich>
  )
})
